import { ValidatorResponse, verificationChartData } from "src/model"

const inputValidator = (data: any, exemptedPropertes?: string[]): ValidatorResponse => {
    var result = <ValidatorResponse>{ isValidated: true }
    for (let key in data) {
        if (!data[key] && !exemptedPropertes?.includes(key)) {
            result.isValidated = false;
            result.message = `Input: Kindly provide ${key}`
            break;
        }
    }
    console.log({result})
    return result
} 

const validateEmail = (email: string): boolean => {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
}

const searchTableData = (tableData: any, searchText: string, propertiesTowatch: any[] = [], propertiesToRemove: any[] = []) => {
    let result = []

    if (!propertiesTowatch.length) {
        propertiesTowatch = Object.keys(tableData[0])
    }

    for (let obj of tableData) { 
        for (let key in obj) {
            if (!propertiesToRemove.includes(key) && propertiesTowatch.includes(key)) {
                if (String(obj[key]).toLowerCase().includes(searchText.toLowerCase())) {
                    result.push(obj)
                    break;
                }
            }
        }
    }

    if (result.length < 1) {
        result = tableData
    }

    return result
}

const splitDateTime = (data: string) => {
    // Convert from '2023-08-23T15:28:26.230Z' to other formats
    let [date, time] = data.split('T')
    let [year, month, day] = date.split('-')
    let [hours, minutes] = time.split(':')

    month = (month.length > 1 && month[0] === '0') ? month[1] : month
    const monthShort = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    const formattedHours = (hours.length > 1 && hours[0] === '0') ? hours[1] : hours

    return {
        date: `${monthShort[Number(month)-1]} ${day}, ${year}`,
        slashedDate: `${day}/${month}/${year}`,
        time: `${hours}:${minutes}`,
        timeEnv: `${Number(formattedHours) < 12 ? 'am' : 'pm'}`,
        completeTime: `${hours}:${minutes}${Number(formattedHours) < 12 ? 'am' : 'pm'}`
    }
}

const duplicateMockData = (sampleRecord: any, noOfRecord: number) => {
    const result = []

    for (let i = 0; i < noOfRecord; i++) {
        result.push(sampleRecord)
    }

    return result
}

const isValidFileType = (filename: string) => {
    let result = true
    let splittedFileName = filename.split('.')
    let extension = splittedFileName[splittedFileName.length - 1].toLowerCase()
    if (!['png', 'jpg', 'jpeg'].includes(extension)) result = false
        return result
}

const convertFileToBase64 = (file: any) => {
    return new Promise(resolve => {
        let fileInfo;
        let baseURL: any = "";
        // Make new FileReader
        let reader = new FileReader();

        // Convert the file to base64 text
        reader.readAsDataURL(file);

        // on reader load somthing...
        reader.onload = () => {
            // Make a fileInfo Object
            baseURL = reader.result;
            baseURL = baseURL.replace('data:image/png;base64,', '').replace('data:image/jpeg;base64,', '').replace('data:image/jpg;base64,', '')
            resolve(baseURL);
        };
    });
};

const normalizeVerificationChartData = (data: Array<verificationChartData>) => {
    const verifiedData = []
    const unverifiedData = []

    for (let item of data) {
        verifiedData.push(item.verifiedCount)
        unverifiedData.push(item.unverifiedCount)
    }

    return {verifiedData, unverifiedData}
}


export default {
    inputValidator,
    validateEmail,
    searchTableData,
    splitDateTime,
    duplicateMockData,
    isValidFileType,
    convertFileToBase64,
    normalizeVerificationChartData
}